import * as React from 'react';
import arrow from '../../../../../assets/images/static_pages/arrow_down.svg';

export const PricingFAQ = () => {
  const [open, setOpen] = React.useState();

  const datas = [
    {
      id: '1',
      question: 'Is there a free version of Avochato?',
      answer: 'Avochato offers a free 14-day trial. If you would like to access Avochato beyond the 14-day trial, you can do so through purchasing one of the paid plans listed.',
    },
    {
      id: '2',
      question: 'Can I sign up with just 1 user?',
      answer: "Yes– all of Avochato's plans are available to single user.",
    },
    {
      id: '3',
      question: 'Can I pay for Avochato monthly?',
      answer: 'Avochato offers a flexible billing structure to accommodate multiple business needs. There are 3 simple components to every billing plan: 1) platform fee, which is billed monthly or annually at an amount that depends on the plan you choose and allows Avochato to provide you with features that your business can take advantage of now and in the future as new features are released; 2) user fee, which is billed monthly or annually at an amount that depends on the plan you choose and allows you to scale your team up from 1 user to as many as you need; 3) account balance, which is billed-as-you-go and allows you to pay for SMS and multimedia messages, carrier fees, and phone call minutes on your own terms. Every Avochato plan comes with a pre-filled account balance to help you get started.',
    },
    {
      id: '4',
      question: 'How does billing work?',
      answer: 'Avochato offers a flexible billing structure to accommodate multiple business needs. There are 3 simple components to every billing plan: 1) platform fee, which is billed monthly or annually at an amount that depends on the plan you choose and allows Avochato to provide you with features that your business can take advantage of now and in the future as new features are released; 2) user fee, which is billed monthly or annually at an amount that depends on the plan you choose and allows you to scale your team up from 1 user to as many as you need; 3) account balance, which is billed-as-you-go and allows you to pay for SMS and multimedia messages, carrier fees, and phone call minutes on your own terms. Every Avochato plan comes with a pre-filled account balance to help you get started.',
    },
    {
      id: '5',
      question: 'What is the platform fee?',
      answer: 'The platform fees shown above give your business access to the powerful platform that Avochato has developed. As Avochato continues to develop new features in the future, these will be available for you to take advantage of as we build the future of messaging software. The platform fee also helps Avochato provide the best possible service and support for your business needs.',
    },
    {
      id: '6',
      question: 'Can I add or remove users?',
      answer: 'Yes. If you decide to add additional users at the per-user prices listed above, you can do so at any time and your billing plan will be updated accordingly. If you decide to remove users, contact our team at sales@avochato.com.',
    },
    {
      id: '7',
      question: 'How does account balance work?',
      answer: "Every Avochato plan comes with a pre-filled account balance to help you get started sending messages. Account balance is billed-as-you-go and allows you to pay for SMS and multimedia messages, carrier fees, international rates, WhatsApp fees, and phone call minutes on your own terms. Account balances do not expire and give you the flexibility to use the product freely without any minimums required on number of messages sent or received. Account balances are non-refundable. You can top up your account balance in 2 ways: 1) manually, with one-time top ups through Avochato's billing portal; 2) automatically by setting a lower limit and a top up amount that replenishes the account once that lower limit is hit. Avochato also offers an upper limit that you can specify to make sure you stay within your budget. You will be notified when your account balance drops below a given threshold, or when your account is auto-topped up.",
    },
    {
      id: '8',
      question: 'Can I see how my account balance is used up?',
      answer: 'Yes. Avochato provides logs for every single message you send or receive. Transparency is key at Avochato, and your business will be able to see the breakdown of how your team is utilizing your account balance. Avochato can notify you when your balance drops below a predefined threshold.',
    },
    {
      id: '9',
      question: 'What if I change my mind?',
      answer: 'If you’ve changed your mind, simply cancel the account in your Avochato billing portal. If you have questions contact us at help@avochato.com or 415-214-8977.',
    },
    {
      id: '10',
      question: 'Do you offer any discounted plans?',
      answer: 'Yes, through choosing a yearly plan you will receive an 18% discount. If you are a 501(c)3 non-profit, you may be entitled to an additional 20% discount.',
    },
    {
      id: '11',
      question: 'Does Avochato offer plans to nonprofits and NGOs?',
      answer: 'Avochato supports organizations that do good in the world. That’s why we offer 20% discounted pricing for qualified non-profit organizations.',
    },
    {
      id: '12',
      question: 'What payment methods does Avochato accept?',
      answer: 'Avochato accepts the following payment methods: All the major credit cards - Visa, Master Card, American Express, Discover, Diners Club, JCB, Carte Bleue, Union Pay. We accept invoices for enterprise contracts that meet a minimum fee - contact our sales team at sales@avochato.com to learn more about invoicing.',
    },
    {
      id: '13',
      question: 'What are carrier fees?',
      answer: "US phone carriers including AT&T, Verizon, T-Mobile, Sprint, and other international carriers charge additional fees per message, ranging from $0.0025 to $0.005 per segment. These are standard industry rates that Avochato passes along to you at no additional mark up. Avochato's account balance feature makes it easy for you to see exactly what thees fees are. Carrier fees are compiled at the end of a business day (midnight Pacific timezone) and are automatically deducted from your account balance.",
    },
    {
      id: '14',
      question: 'How about US taxes?',
      answer: "Depending on the state in which you operate, you may be subject to taxes. Avochato's billing portal will show you if there are any taxes due at the time of payment.",
    },
  ];

  const handleClick = (e) => setOpen(open === e.currentTarget.id ? null : e.currentTarget.id);

  const sections = datas.map((data) => {
    const isOpen = open === data.id;

    return (
      <div
        key={data.id}
        id={data.id}
        className="col-section"
        onClick={handleClick}
      >
        <div className="flex justify-between">
          <p className={`fsz-16 ${isOpen ? 'bold-800' : ''}`}>{data.question}</p>
          <span className="arrow">
            <img className={`white ${isOpen ? 'flip' : ''}`} src={arrow} alt="arrow" />
          </span>
        </div>
        <p className={`fsz-15 mt-10 ${isOpen ? '' : 'hide'}`}>{data.answer}</p>
      </div>
    );
  });

  return (
    <div id="pricing-faq">
      <p className="header">Pricing FAQ</p>
      <div className="section-containers">
        {sections}
      </div>
    </div>
  );
};
